import { ADJUST_TEXT_SIZE, CHANGE_LANG } from "../actions/actions.types";

const INITIAL_STATE = {
    textSize: 'normal',
    lang: 'en',
    returnUrl: null,
}

const appSettingsReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case ADJUST_TEXT_SIZE:
            return {
                ...state,
                textSize: action.payload
            }
        
        case CHANGE_LANG:
            return {
                ...state,
                lang: action.payload
            }
        
        default:
            return state
    }
}

export default appSettingsReducer;